import { SalaryScale } from './../../../../admin/model/salary-scale.model';
import {Pagination} from '../pagination.model';

export class SalaryScalePage extends Pagination {
  content: SalaryScale[] = [];
}
